module.exports = __webpack_public_path__ + "static/img/r-3-4.f2c8176.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-3/r-3-4.png
// module id = xPf6
// module chunks = 0